export const baseURL = 'https://'+process.env.REACT_APP_DOMAIN_NAME+'/v1/'
export const websocketURL = 'wss:websocket-'+process.env.REACT_APP_DOMAIN_NAME+'/v1'
export const stage = process.env.REACT_APP_DOMAIN_NAME
